import { usePathname, useSearchParams } from 'next/navigation';
import { useMemo } from 'react';
import useVehicleFacets from '@//data/search/vehicles/useVehicleFacets';
import { clientParamsResolver } from './utils';

const useVehicleSearchParams = (rootUrl: string) => {
  const vehicleFacetsQuery = useVehicleFacets();
  const facets = vehicleFacetsQuery.data;
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const params = useMemo(
    () =>
      clientParamsResolver({
        searchParams,
        pathname,
        initialResponse: facets!,
        searchPagePath: rootUrl,
      }),
    [searchParams.toString(), pathname, facets, rootUrl],
  );
  return params;
};

export default useVehicleSearchParams;
